module.exports = __webpack_public_path__ + "src/assets/img/goodsList.51f2e074.png";